import apiBase from "../../api/axios";

const BASE = "v1/talentos-global/conversaciones";

export const listarConversacionesService = async () => {
  const response = await apiBase.get(`${BASE}/`);
  return response.data;
};

export const obtenerConversacionService = async (id) => {
  const response = await apiBase.get(`${BASE}/${id}/`);
  return response.data;
};

export const editarConversacionService = async (id, payload) => {
  const response = await apiBase.patch(`${BASE}/${id}/`, payload);
  return response.data;
};
